
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_11ojs_94",
  "input": "awsui_input_2rhyz_11ojs_98",
  "input-readonly": "awsui_input-readonly_2rhyz_11ojs_119",
  "input-invalid": "awsui_input-invalid_2rhyz_11ojs_180",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_11ojs_191",
  "input-type-search": "awsui_input-type-search_2rhyz_11ojs_196",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_11ojs_212",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_11ojs_215",
  "input-container": "awsui_input-container_2rhyz_11ojs_219",
  "input-icon": "awsui_input-icon_2rhyz_11ojs_224",
  "input-icon-hoverable": "awsui_input-icon-hoverable_2rhyz_11ojs_227",
  "input-icon-left": "awsui_input-icon-left_2rhyz_11ojs_231",
  "input-icon-right": "awsui_input-icon-right_2rhyz_11ojs_236"
};
  